import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../utils/variants";
import breakout from "../assets/Breakout.png";
import keynote from "../assets/Keynote.png";
import networking from "../assets/Networking.png";
function Programs() {
  return (
    <div className="flex h-fit py-24 items-center justify-around border-black border-t-4 border-b-2">
      <div className="w-[90%] mx-auto h-fit flex flex-col gap-5 items-center">
        <motion.h2
          variants={fadeIn("down", 0.4)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.4 }}
          className="text-4xl font-semibold tracking-widest text-black"
        >
          Event Highlight
        </motion.h2>
        <div className="flex max-lg:h-fit max-lg:flex-col max-lg:gap-8 justify-between h-[500px] w-full items-center">
          {/* Break-Out Session */}
          <motion.div
            variants={fadeIn("up", 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.4 }}
            className="w-[30%] max-lg:w-full h-full relative rounded-xl border-black border-[3px] overflow-hidden shadow-nottailwindprogramscardred"
          >
            <img
              src={breakout}
              alt=""
              className="w-full h-full object-cover brightness-50"
            />
            <div className="flex flex-col gap-3 absolute bottom-5 left-5 ">
              <h3 className="text-white font-semibold text-3xl">
                Break-Out <br /> Session
              </h3>
              <p className="text-white font-light text-base">
                Brief descriptions of hands-on sessions
              </p>
            </div>
          </motion.div>

          {/* Keynotes */}
          <motion.div
            variants={fadeIn("up", 0.4)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.4 }}
            className="w-[30%] max-lg:w-full h-full relative rounded-3xl border-black border-[3px] overflow-hidden shadow-nottailwindprogramscard"
          >
            <img
              src={keynote}
              alt=""
              className="w-full h-full object-cover brightness-50"
            />
            <div className="flex flex-col gap-3 absolute bottom-5 left-5 ">
              <h3 className="text-white font-semibold text-3xl">Keynotes</h3>
              <p className="text-white font-light text-base">
                Focus on future tech trends (Blockchain, Web3, AI)
              </p>
            </div>
          </motion.div>

          {/* Networking */}
          <motion.div
            variants={fadeIn("up", 0.4)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.4 }}
            className="w-[30%] max-lg:w-full h-full relative rounded-3xl border-black border-[3px] overflow-hidden shadow-nottailwindprogramscardbrown"
          >
            <img
              src={networking}
              alt=""
              className="w-full h-full object-cover brightness-50"
            />
            <div className="flex flex-col gap-3 absolute bottom-5 left-5 ">
              <h3 className="text-white font-semibold text-3xl">Networking</h3>
              <p className="text-white font-light text-base">
                Highlight opportunities to connect with others
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Programs;
